import { type FC, Fragment, type PropsWithChildren } from 'react';
import { Container } from 'react-bootstrap';

import RegisteredWrapper from '@/components/RegisteredWrapper.tsx';
import type TranslationKey from '@/lib/i18n/TranslationKey.ts';
import useTitle from '@/lib/useTitle.ts';

import Footer from '../Footer.tsx';
import ConventionHeaderBig from './ConventionHeaderBig.tsx';

type RegisterLayoutProps = {
  title: TranslationKey;
  bannerTitle?: TranslationKey;
  noLogin?: boolean;
};

const RegisterLayout: FC<PropsWithChildren<RegisterLayoutProps>> = ({
  title,
  bannerTitle,
  noLogin,
  children,
}) => {
  useTitle(title);

  const Wrapper = noLogin ? Fragment : RegisteredWrapper;

  return (
    <Wrapper>
      <div className="d-flex flex-column min-vh-100">
        <div className="flex-grow-0 flex-shrink-1">
          <ConventionHeaderBig title={bannerTitle} />
        </div>
        {/* CON-SPECIFIC: Ultra background class */}
        <div className="position-relative flex-grow-1 flex-shrink-1 pb-5 ultra-background-1-dark">
          <Container>{children}</Container>
        </div>
        <div className="flex-grow-0 flex-shrink-1">
          <Footer />
        </div>
      </div>
    </Wrapper>
  );
};

export default RegisterLayout;
